import { gql, useQuery } from '@apollo/client';

const CHECK_TRADING_AGREEMENT_QUERY = gql`
    query checkTradingAgreement {
        tradingAgreement {
            completed
            completedAt
            agreementId
        }
    }
`;

interface TradingAgreementStatus {
    completed: boolean;
    completedAt?: string;
    agreementId?: string;
}

interface CheckTradingAgreementResponse {
    tradingAgreement: TradingAgreementStatus;
}

export const useCheckTradingAgreement = () => {
    const { data, loading, error, refetch } = useQuery<CheckTradingAgreementResponse>(CHECK_TRADING_AGREEMENT_QUERY, {
        fetchPolicy: 'network-only', // Always fetch fresh data
    });

    return {
        hasAgreement: data?.tradingAgreement?.completed ?? false,
        agreementData: data?.tradingAgreement,
        loading,
        error,
        refetch,
    };
};
